export type BrandFeatureName =
  typeof BrandFeatureNameDescriptions[number]['key'];

export const BrandFeatureNameDescriptions: {
  description: string;
  key: string;
}[] = [
  {
    description: 'Autorise la gestion des véhicules de prêt pour ce fitter',
    key: 'can-declare-replacement-vehicle-fitter',
  },
  {
    description:
      "Permet d'envoyer un mail à un Admin (mail en conf) après chaque RDV réservé",
    key: 'send-fitteradmin-link-after-book',
  },
  {
    description:
      "Recompose l'adresse envoyée au fitter, avec un format streetNumber + streetName en plus de code postal et de ville.",
    key: 'new-mobility-book-address-style',
  },
  {
    description:
      "N'autorise la récupération de fitters que en PRODUCTION (pas en DEV, ni en INTEG, ni en DEMO, ni en REC)",
    key: 'can-only-get-partners-in-production',
  },
  {
    description:
      'Empêche le fallback sur internalId quand codeFce manque pour un insurer (permet de ne pas envoyer de RDV à un fitter qui n’a pas de codeFce pour l’assureur)',
    key: 'no-fce-internal-id-fallback',
  },
  {
    description:
      "N'autorise la finalisation de réservation de RDV que en PRODUCTION (pas en DEV, ni en INTEG, ni en DEMO, ni en REC)",
    key: 'can-only-book-appointment-in-production',
  },
  {
    description: 'Autorise la modification de RDV pour ce fitter',
    key: 'can-do-appointment-modification-fitter',
  },
  {
    description: "Autorise l'annulation de RDV pour ce fitter",
    key: 'can-do-appointment-cancel-fitter',
  },
  {
    description: "Autorise la modification d'une fiche client pour ce fitter",
    key: 'can-do-request-appointment-modification-fitter',
  },
  {
    description: "Autorise l'annulation d'une fiche client pour ce fitter",
    key: 'can-do-request-appointment-cancel-fitter',
  },
  {
    description: "Autorise la reprise d'un RDV annulé pour ce fitter",
    key: 'can-do-appointment-modification-after-cancel-fitter',
  },
  {
    description: 'Autorise la gestion de la pose à domicile pour ce fitter',
    key: 'fitter-in-mobility-service',
  },
  {
    description:
      'Permet de gérer un nom spécifique pour le garage en complément du nom du réseau',
    key: 'can-declare-fitter-brand-name',
  },
  {
    description:
      'Permet de renseigner à qui appartient le véhicule du dossier si ce fitter est sélectionné',
    key: 'fitter-allow-car-ownership',
  },
  {
    description: 'Permet de créer un nouveau rendez-vous sans API',
    key: 'can-create-light-appointment',
  },
  {
    description: "Permet d'utiliser l'API Partoo",
    key: 'can-use-partoo-api',
  },
  {
    description: "Permet au fitter de changer le nom des centres qu'il gère",
    key: 'agenda-can-declare-own-fitter-brand-name',
  },
  {
    description:
      "Permet d'utiliser l'identifier goolge Place comme id pour les centres",
    key: 'use-google-id',
  },
  {
    description: 'Permet de ne pas afficher la note et les avis google',
    key: 'no-display-google-reviews',
  },
  {
    description:
      "Permet d'utiliser google pour les adresses des centres (nécessite use-google-id)",
    key: 'use-google-data-for-address',
  },
  {
    description:
      "Permet d'utiliser google pour les localisations des centres (nécessite use-google-id)",
    key: 'use-google-data-for-location',
  },
  {
    description:
      "Permet d'utiliser google pour les horaires d'ouvertures des centres (nécessite use-google-id)",
    key: 'use-google-data-for-openinghours',
  },
  {
    description:
      'Permet de ne pas mettre à jour les adresses, tel et email des centres (pour les brands qui ont déjà une synchro par ailleurs)',
    key: 'dont-update-details',
  },
  {
    description:
      "Permet d'envoyer l'addresse du centre en param de la requète de book",
    key: 'send-partner-branch-address-on-book',
  },
  {
    description:
      "Permet d'activer tout le processus d'envoi de fiche client en b2b pour une brand",
    key: 'b2b-allow-appointment-request',
  },
  {
    description:
      "Permet d'activer tout le processus d'envoi de fiche client en b2c pour une brand",
    key: 'b2c-allow-appointment-request',
  },
  {
    description:
      "Active l'envoi des mails respectifs au fitter après demande de RDV par fiche client côté B2B (ne pas utiliser dans une config dédiée à l'agenda avec la feature agenda-send-fitter-link-after-request activée)",
    key: 'send-fitter-link-after-request',
  },
  {
    description:
      "Active l'envoi des mails respectifs à l'assuré après demande de RDV",
    key: 'send-customer-link-after-request',
  },
  {
    description:
      "Permet d'activer le processus d'envoi de fiche client par API même dans les cas où le fitterId est inconnu (ne doit être activé que sur les conf garagistes)",
    key: 'allow-appointment-request-without-id',
  },
  {
    description:
      "Active l'envoi des mails respectifs aux superviseurs l'assureur après demande de RDV si le fitterId est inconnu",
    key: 'send-supervisors-link-after-request-without-fitter-id',
  },
  {
    description: 'Active la différentiation des custode avant et arrière',
    key: 'damage-glass-custode-differentiation',
  },
  {
    description:
      "Permet d'afficher les PAD avec 'Matin' et 'Après-midi' au lieu des crénaux précis",
    key: 'display-PAD-as-half-day',
  },
  {
    description: "Active l'envoi des mails d'annulatiobn au fitter ",
    key: 'send-fitter-link-after-cancel',
  },
  {
    description:
      'Gestion des synchros partenaires (noremove = désactive la supression de centre = upsert only',
    key: 'partners-sync-noremove',
  },
  {
    description:
      "Demande d'envoie d'un email de notification dans le cadre de l'agenda",
    key: 'ask-fitter-send-customer-email-after-book-or-cancel',
  },
  {
    description:
      "Permet d'afficher les propositions de créneau à domicile sur la page d'un fitter venant d'autre fitters de la même brand",
    key: 'diplay-other-fitters-PAD-slots',
  },
  {
    description:
      'Permet de considérer les fitters de cette brand comme généralistes et donc de pouvoir les filtrer dans les listes de recherche (toggle)',
    key: 'fitter-generalist-service',
  },
  {
    description:
      "Permet d'envoyer un mail de fiche client sans piece jointe et avec un bouton de redirection",
    key: 'securized-requested-appointment-mail',
  },
  {
    description:
      "Permet d'activer la fonctionnalité direct connect, qui utilise une API séparée pour le fetch de la brand",
    key: 'fitter-direct-agenda-connect',
  },
  {
    description:
      'Permet au B2B de valider les fiches client avec un bouton à la fin du parcours et de voir des stats les concernant',
    key: 'can-validate-request-appointment',
  },
  {
    description:
      'Permet de pousser aux partenaires les franchises dans le champs commentaire de la requête de book',
    key: 'push-deductible-on-book-comment',
  },
  {
    description:
      "Permet d'afficher un centre d'une brand uniquement en mobilité dans le cas où on sélectionne un vitrage qui ne permet pas la prise de rdv via l'appli",
    key: 'display-mobile-fitter-on-special-glass',
  },
  {
    description: "Empêche l'annulation à partir d'un email",
    key: 'difficult-appointment-cancel-fitter',
  },
  {
    description:
      "Permet à l'assureur de déclarer des évènements climatiques sur cette brand, ce qui empèche la prise de RDV et affiche un bandeau d'alerte aux clients",
    key: 'can-declare-weather-event',
  },
  {
    description: "Permet d'afficher une info de surcout pour la mobilité",
    key: 'show-mobility-no-cost-info',
  },
  {
    description:
      'Affiche la zone de saisie de commentaire à la fin du parcours B2C',
    key: 'show-comment-section',
  },
  {
    description:
      "Permet de retarder l'affichage des garages sans RDV dans la page de recherche",
    key: 'should-display-later',
  },
];
